import { useState } from "react";
import styles from "./ShareAssessment.module.scss";
import { ModalOverlay } from "../ModalOverlay";
import { useMutation } from '@apollo/client';
import { SHARE_ASSESSMENT } from '../../apollo/queries';
import { ShareAssessmentForm } from '../ShareAssessmentForm';

export interface AssessmentShareData {
    name: string;
    emailAddress: string;
    language: string
}

type ShareAssessmentData = {
    isOpen: boolean,
    onOpenChange: Function
    shareContent: {
        id: number,
        scanType: string
        companyName: string
        assessmentDate?: string
    }
}

export const ShareAssessment = ({
    onOpenChange,
    isOpen = false,
    shareContent
}: ShareAssessmentData) => {
  // const [isOpen, setIsOpen] = useState(false);
  const [sendingSuccessful, setSendingSuccessful] = useState(false);
  const [errorFound, setErrorFound] = useState(false);

    const [shareAssessmentAction] = useMutation(SHARE_ASSESSMENT, {
        onCompleted: (data) => {
            if(data !== null && data.shareAssessment.code === 200) {
                setSendingSuccessful(true)
                setErrorFound(false)
                setTimeout(() => {
                    onOpenChange(!isOpen);
                    setSendingSuccessful(false)
                }, 1500)
            }
        },
        onError: () => {
            setErrorFound(true)
            setTimeout(() => {
                onOpenChange(!isOpen);
                setSendingSuccessful(false)
                setErrorFound(false)
            }, 2500)
        }
    });

  const handleSendEmail = async (formData: AssessmentShareData, message: String) => {
    shareAssessmentAction({
        variables: {
            name: formData.name,
            emailAddress: formData.emailAddress,
            scanType: shareContent.scanType,
            message,
            assessmentId: shareContent.id,
            language: formData.language
        },
    })
  };

  const handleOpenSend = () => {
      onOpenChange(!isOpen);
  };

    return (
    <div className={styles.wrapper}>
      <ModalOverlay show={isOpen}>
        <ShareAssessmentForm
          isOpen={isOpen}
          onToggle={handleOpenSend}
          onClick={handleSendEmail}
          sendingSuccessful={sendingSuccessful}
          errorFound={errorFound}
            // @ts-ignore
          row={shareContent}
        />
      </ModalOverlay>
    </div>
  );
};
